import { Eye, FileSpreadsheet, FileText } from "lucide-react";

/**
 * Uniform View / Excel / PDF actions for report cards.
 */
export default function ReportActions({
  busy,
  onView,
  onExcel,
  onPdf,
  showPdf = true,
  variant = "grid",
}) {
  const disabled = !!busy;
  const rootClass =
    variant === "enterprise"
      ? "rpt-actions rpt-actions--enterprise"
      : "rpt-actions";

  return (
    <div className={rootClass} role="group" aria-label="Report actions">
      <button type="button" className="rpt-btn rpt-btn--primary" disabled={disabled} onClick={onView}>
        <Eye size={16} strokeWidth={2.25} />
        View
      </button>
      <button type="button" className="rpt-btn rpt-btn--excel" disabled={disabled} onClick={onExcel}>
        <FileSpreadsheet size={16} strokeWidth={2.25} />
        Excel
      </button>
      {showPdf ? (
        <button type="button" className="rpt-btn rpt-btn--pdf" disabled={disabled} onClick={onPdf}>
          <FileText size={16} strokeWidth={2.25} />
          PDF
        </button>
      ) : (
        variant === "grid" && <span className="rpt-actions__spacer" aria-hidden="true" />
      )}
    </div>
  );
}
